import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, CircularProgress, Alert } from '@mui/material';
import { useEffect, useState } from "react";
import BusinessInfoDropList from "./BusinessInfoDropList";
import { useApiService } from "../../../../../services/ApiService/ApiService";
import toast from 'react-hot-toast';

function checking_null_undefined(array: any) {
    if (array === null || array === undefined) {
        return [];
    }
    return array;
}

function SelectedFleetModal(props: any) {
    const [modalIsOpen, setIsOpen] = props.modalIsOpen;
    const [userInfo, setUserInfo] = props.userInfo;
    const [isError, setIsError] = useState(false);
    const [businessInfo, setBusinessInfo] = useState([]) as any;
    const [loading, setLoading] = useState(true);
    const { fetchWithAuth } = useApiService();

    function closeModal() {
        setIsOpen(false);
    }

    async function fetchBusinessInfo() {
        try {
            const response = await fetchWithAuth('/business/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    accountUuid: userInfo.accountUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch business info');
            }

            const res_json = await response.json();
            setBusinessInfo(checking_null_undefined(res_json.businesses));
            setIsError(false);
        } catch (error) {
            console.error('Error fetching business info:', error);
            setIsError(true);
            toast.error('Failed to load business information');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchBusinessInfo();
    }, []);

    return (
        <Dialog 
            open={modalIsOpen}
            onClose={closeModal}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 1,
                }
            }}
        >
            <DialogTitle
                sx={{
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    py: 1,
                }}
            >
                Choose Fleet
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : isError ? (
                    <Box sx={{ p: 2 }}>
                        <Alert severity="error">
                            Failed to load business information. Please try again.
                        </Alert>
                    </Box>
                ) : (
                    <Box sx={{ py: 2 }}>
                        {businessInfo.map((item: any, index: any) => (
                            <BusinessInfoDropList
                                closeModal={closeModal}
                                userInfo={props.userInfo}
                                key={index}
                                title={item.name}
                                businessUuid={item.uuid}
                                chargingCategory={item.chargingCategory}
                                businessProducts={item.products}
                                list={checking_null_undefined(item.fleets)}
                            />
                        ))}
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 2, py: 1.5 }}>
                <Button onClick={closeModal} variant="outlined" color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SelectedFleetModal;
